//
//
//
//
//
//
//
//
//

import { operateCreditlist } from '@/api/user'
import md5 from 'vux/src/tools/md5/index.js'
export default {
  name: 'test',
  props: {},
  data () {
    return {}
  },
  created () {
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    }
  },
  mounted () {
    this.addCredit()
    this.link()
  },
  methods: {
    addCredit () {
      operateCreditlist({
        accountid: this.accountid,
        rulecode: 'hgsc',
        owner_type: this.$config.owner_type
      }).then(res => { })
    },
    link () {
      let temp = 'appKey=20210813114859096&outerMemberId=' + this.userid + '&phone=' + this.$store.state.user.personObj.mobile + '&targetURL=13&tenant=youzhenggonghuiiz6hk3EQ1D2xEgAw'
      let a = md5(temp.toLowerCase())
      let link = 'https://saash5.namek.com.cn/v4/pages/auth/thirdPageIn?tenant=youzhenggonghui&appKey=20210813114859096&targetURL=13&phone=' + this.$store.state.user.personObj.mobile + '&outerMemberId=' + this.userid + '&sign=' + a
      window.location.href = link
    }
  }
}
